import { SVGProps } from 'react';

const ErrorIcon = ({
  height = '44px',
  width = '44px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    id='Icons_Actions_ic-actions-danger'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    className='stroke-current'
    viewBox='0 0 44 44'
    {...props}
  >
    <g id='ic-actions-danger' transform='translate(2.755 2.755)'>
      <path
        id='Path_12'
        data-name='Path 12'
        d='M19.116,3.053,1.7,37.887a1.833,1.833,0,0,0,1.632,2.658H38.164A1.833,1.833,0,0,0,39.8,37.887L22.379,3.053a1.833,1.833,0,0,0-3.263,0Z'
        transform='translate(-1.503 -2.056)'
        fill='none'
        stroke='#e07f62'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
      />
      <rect
        id='Rectangle_7'
        data-name='Rectangle 7'
        width='3.667'
        height='16.5'
        rx='1'
        transform='translate(17.411 9.706)'
        fill='none'
        stroke='#e07f62'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth={strokeWidth}
      />
      <rect
        id='Rectangle_8'
        data-name='Rectangle 8'
        width='4.895'
        height='4.895'
        rx='1.33'
        transform='translate(16.806 29.836)'
        fill='none'
        stroke='#e07f62'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);

export default ErrorIcon;
